export default __webpack_public_path__ + "static/media/hero6.966712b4.jpg";